import { useState, type InputHTMLAttributes } from 'react';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
};

const PasswordInput = ({ label, ...props }: PasswordInputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <label>
      <span>{label}</span>
      <div className="password-field">
        <input
          {...props}
          type={visible ? 'text' : 'password'}
        />
        <button
          type="button"
          className="password-toggle"
          aria-label={visible ? 'Wachtwoord verbergen' : 'Wachtwoord tonen'}
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
        >
          {visible ? '🙈' : '👁'}
        </button>
      </div>
    </label>
  );
};

export default PasswordInput;
